<script lang="ts">
	import { chatT } from '@repo/commons/i18n/chat'
	interface Props {
		data: string
	}

	let { data }: Props = $props()

	const keyValuesPair = $derived.by(() => {
		const parsed = JSON.parse(data)
		return Object.entries(parsed).map(([key, value]) => ({ key, value }))
	})
</script>

<div>
	<div class="form-submitted-text">{$chatT('FormSubmitted')}</div>

	<div class="form-label mb-4">{$chatT('SubmittedData')}</div>

	<div class="key-value-list">
		{#each keyValuesPair as item}
			<div class="key-value-pair">
				<div class="form-label">{item.key}:</div>
				<div class="form-value">{item.value}</div>
			</div>
		{/each}
	</div>
</div>

<style lang="postcss">
	.form-submitted-text {
		@apply text-[rgba(0,22,38,0.9)] text-[16px] font-normal leading-[24px] mb-[12px];
	}

	.form-label {
		@apply text-[rgba(0,22,38,0.9)] text-[16px] font-bold leading-[24px];
	}

	.form-value {
		@apply text-[rgba(0,22,38,0.9)] text-[16px] font-normal leading-[24px];
	}

	.key-value-list {
		@apply flex flex-col gap-[20px];
	}
</style>
